import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GraphRole, GraphRoles } from '../models/graph-role' ;
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, expand, reduce } from 'rxjs/operators';
import { GraphUser } from '@models';

@Injectable()
export class GraphApiService {
  private readonly graphVersion: string = `v1.0`;
  private readonly graphUrl: string = `https://graph.microsoft.com/${ this.graphVersion }`;

  public constructor(protected http: HttpClient) { }

  public getUser(): Observable<GraphUser> {
    const properties = Object.keys(new GraphUser()).join(',');
    const userUrl = `${ this.graphUrl }/me?$select=${ properties }`;

    return this.http.get<GraphUser>(userUrl);
  }

  public getUserPhoto(): Observable<Blob> {
    const userPhotoUrl = `${ this.graphUrl }/me/photo/$value`;

    return this.http.get(userPhotoUrl, { responseType: 'blob' });
  }

  public getUsersByLastName(lastName: string): Observable<GraphUser[]> {
    const url = this.graphUrl+`/users?$select=givenName,displayName,surname,mail&$filter=startswith(surname,'${lastName}')`;
    return this.http.get<GraphUser[]>(url);
  }

  public getCurrentUserEmailAddress(): Observable<GraphUser[]> {
    const url = this.graphUrl+`/me/mail`;
    return this.http.get<GraphUser[]>(url);
  }

  // noinspection JSUnusedGlobalSymbols
  public getUserRoles(): Observable<GraphRole[]> {
    const properties = Object.keys(new GraphRole()).join(',');
    const userRolesUrl = `${ this.graphUrl }/me/memberOf?$select=${ properties }`;

    const accumulateRolesFromPage = (accumulator: GraphRole[], currentPage: GraphRoles): GraphRole[] => accumulator.concat(...currentPage.value);

    const getNextPage = (currentPage: GraphRoles): Observable<GraphRoles> => {
      if (currentPage['@odata.nextLink'] === null || currentPage['@odata.nextLink'] == undefined) {
        return EMPTY;
      }

      return this.http.get<GraphRoles>(currentPage['@odata.nextLink']);
    };

    const getFirstPage = () => this.http.get<GraphRoles>(userRolesUrl);

    return getFirstPage().pipe(
      expand(getNextPage),
      reduce(accumulateRolesFromPage, [])
    );
  }

}
